import type { DRBFMSession } from '../../../types';

export const STAGED_WORKBENCH_SOURCE = 'staged_workbench';

export const isStagedSession = (session: DRBFMSession) =>
  session.workflowMetadata?.source === STAGED_WORKBENCH_SOURCE;

// Only the boolean the mainline service writes counts (mainline_service.py).
export const isMainlineSession = (session: DRBFMSession) =>
  session.workflowMetadata?.mainline === true;

// Mainline wins over staged: once enrolled, only mainline commands may write the session.
export const sessionOpenPath = (session: DRBFMSession) => {
  if (isMainlineSession(session)) return `/drbfm?edit=1&session=${session.id}`;
  if (isStagedSession(session)) return `/drbfm?session=${session.id}&mode=staged`;
  return `/drbfm?session=${session.id}`;
};

const workspacePath = (sessionId: string) => `/drbfm?results=1&session=${sessionId}`;

// Mozy #1612: the workspace only for an enrolled session with mainline on; with it off every path is as before.
const opensWorkspace = (session: DRBFMSession | null, mainlineEnabled: boolean) =>
  mainlineEnabled && session !== null && isMainlineSession(session);

/** The mainline editor's "View results". */
export const sessionResultsPath = (sessionId: string, session: DRBFMSession | null, mainlineEnabled: boolean) =>
  (opensWorkspace(session, mainlineEnabled) ? workspacePath(sessionId) : `/drbfm?session=${sessionId}`);

const hasEditor = (session: DRBFMSession) => isMainlineSession(session) || isStagedSession(session);

/** The history page's 「結果を表示」; otherwise a session keeps where it opens today. */
export const sessionViewResultsPath = (session: DRBFMSession, mainlineEnabled: boolean) =>
  (opensWorkspace(session, mainlineEnabled) ? workspacePath(session.id) : sessionOpenPath(session));

export const canResumeSession = (session: DRBFMSession) => session.status !== 'completed' && hasEditor(session);

export const canOpenSession = (session: DRBFMSession) => session.status === 'completed' || hasEditor(session);
